import { render, staticRenderFns } from "./CIP.vue?vue&type=template&id=78d20410&"
import script from "./CIP.vue?vue&type=script&lang=js&"
export * from "./CIP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Avijeh.Projects\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78d20410')) {
      api.createRecord('78d20410', component.options)
    } else {
      api.reload('78d20410', component.options)
    }
    module.hot.accept("./CIP.vue?vue&type=template&id=78d20410&", function () {
      api.rerender('78d20410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/CIP/CIP.vue"
export default component.exports